<template>

  <!-- 路由 -->
  <div id="app"><router-view /></div>

  <!-- loading 组件 -->
  <div id="TTLloading">
  <div id="TTLloadingbox" class="TTL-loading-box">
  <div class="TTL-loading-box-main">
  <div class="spinner">
  <div class="bounce1"></div>
  <div class="bounce2"></div>
  <div class="bounce3"></div>
  </div>
  <span id="TTLloadingtitle" class="TTL-loading-box-title">正在加载中，请稍等......</span>
  </div>
  </div>
  </div>
  <!-- loading 组件 -->

  <!-- loading 组件（数据加载loading）-->
  <div id="TTLloadingbox2" class="TTL-loading-box-2">
  <div class= "sk-cube-grid">
  <div class= "sk-cube sk-cube1"></div>
  <div class= "sk-cube sk-cube2"></div>
  <div class= "sk-cube sk-cube3"></div>
  <div class= "sk-cube sk-cube4"></div>
  <div class= "sk-cube sk-cube5"></div>
  <div class= "sk-cube sk-cube6"></div>
  <div class= "sk-cube sk-cube7"></div>
  <div class= "sk-cube sk-cube8"></div>
  <div class= "sk-cube sk-cube9"></div>
  </div>
  </div>
  <!-- loading 组件（数据加载loading）-->

  <!-- file 文件上传 - 单图 -->
  <div class="TTL-Files">
  <input type="file" id="TTLFiles" />
  </div>
  <!-- file 文件上传 - 单图 -->

  <!-- file 文件上传 - 多图 -->
  <div class="TTL-Files">
  <input type="file" id="TTLFilesmore" multiple />
  </div>
  <!-- file 文件上传 - 多图 -->

</template>


<script>
export default {
  name: 'App',
}
</script>
